import qs from "querystring";

const queryObj = typeof location !== "undefined" ? qs.parse(location.search.slice(1)) : {};

const get = (key: string) => queryObj[key];
const extend = (obj: Record<string, string>) => {
  let key: string, val: string;
  const copy: Record<string, string> = {};
  for (key in queryObj) {
    // @ts-expect-error Type 'string | string[] | undefined' is not assignable to type 'string'.
    val = queryObj[key];
    copy[key] = val;
  }
  for (key in obj) {
    val = obj[key];
    copy[key] = val;
  }
  return copy;
};
const stringify = (obj: Record<string, string>) => qs.stringify(obj);

const query = {
  get,
  extend,
  stringify,
};
export default query;
